export interface PersonalAttr {
  name: string
  type: string
  placeholder: string
  display: boolean
  required: boolean
  note: string
}

export class Question {
  /**
   * 設問のID
   *
   * フロントエンドで割り振ります。
   * Book内で一意です。
   * 主にアニメーションのための識別用。
   */
  id = 0
  question = ''
  type = ''
  placeholder = ''
  qa = ''
  qb = ''
  qc = ''
  qd = ''
  qe = ''
  required = false
  readonly = false
  suffix = ''
  prefix = ''

  constructor(initData?: Partial<Question>) {
    Object.assign(this, initData)
  }
}

export class Book {
  /** DB上ではNullableだが、データ作成時に必ずセットされるのでNullableにしない。*/
  bookHash = ''
  bookId = ''
  bookLimitDt: string | null = null
  bookName: string | null = null
  bookNote: string | null = null
  bookPass: string | null = null
  bookEMList: string | null = null

  /** DB上ではNullableだが、仕様上削除できないのでNullableにしない。 */
  personalAttr: { [key: string]: PersonalAttr } = {}

  /** DB上ではNullableだが、設問を全削除した状態で保存はできないのでNullableにしない。 */
  questions: Question[] = []

  sheetHash = ''
  sheetLimitUnit = ''
  /** sheetStartDt から生成される */
  sheetStartDay = ''
  sheetStartDt: string | null = null
  /** sheetStartDt から生成される */
  sheetStartTime = ''
  sheetTermHour: string | null = null

  url = {
    answer: '',
    bookcsv: '',
    bookexcel: '',
    facebook: '',
    line: '',

    ogp_description: '',
    ogp_image: '',
    ogp_site_name: '',
    ogp_title: '',
    ogp_type: '',
    ogp_url: '',

    page: '',
    pdf: '',
    qrcode: '',
    twitter: '',
  }

  userId: string | null = null

  delDt: string | null = null
  delFlg: '0' | '1' = '0'
  insDt: string | null = null
  updDt: string | null = null
}
